import React from 'react';
import { RefreshCw } from 'lucide-react';

interface BatchProgress {
  currentBatch: number;
  totalBatches: number;
  processedItems: number;
  totalItems: number;
  successCount: number;
  errorCount: number;
  failedRows: number[];
}

interface BatchProgressModalProps {
  isOpen: boolean;
  progress: BatchProgress | null;
  isOnline: boolean;
}

const BatchProgressModal: React.FC<BatchProgressModalProps> = ({
  isOpen,
  progress,
  isOnline
}) => {
  if (!isOpen || !progress) return null;

  const progressPercentage = (progress.processedItems / progress.totalItems) * 100;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 pointer-events-none">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 pointer-events-auto">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Regenerating All Metadata</h3>
        <p className="text-sm text-gray-500 mb-4">⚠️ This process cannot be interrupted. Please wait until completion.</p>

        <div className="mb-6">
          <div className="flex justify-between text-sm text-gray-600 mb-2">
            <span>Progress</span>
            <span>{progress.processedItems}/{progress.totalItems}</span>
          </div>

          <div className="w-full bg-gray-200 rounded-full h-2 mb-4">
            <div
              className="bg-blue-600 h-2 rounded-full transition-all duration-300"
              style={{ width: `${progressPercentage}%` }}
            ></div>
          </div>

          <div className="text-sm text-gray-600 space-y-1">
            <p>Batch: {progress.currentBatch}/{progress.totalBatches}</p>
            <p>Success: {progress.successCount}</p>
            <p>Failed: {progress.errorCount}</p>
          </div>
        </div>

        <div className={`p-3 border rounded-lg ${
          isOnline
            ? 'bg-blue-50 border-blue-200'
            : 'bg-yellow-50 border-yellow-200'
        }`}>
          <p className={`text-sm ${
            isOnline ? 'text-blue-800' : 'text-yellow-800'
          }`}>
            {isOnline ? (
              <>🔄 Processing... Please keep this window open. Credits are being charged.</>
            ) : (
              <>⚠️ Connection lost. Process will resume when back online. Credits are still being charged.</>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default BatchProgressModal;

